import { useState } from "react";
import "./Vizionario.css";
import { login } from "../../services/vizionarioService";
import { useVizionarioStore } from "../../store/useVizionarioStore";
import spinner from "../../assets/images/loading.svg";
import closeEye from "../../assets/images/close-eye.svg";
import openEye from "../../assets/images/open-eye.svg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const { setShowLogin } = useVizionarioStore.getState();
  const loading = useVizionarioStore((state) => state.loading);

  const handleCancel = () => {
    setEmail("");
    setPassword("");
    setPasswordType("password");
    setShowLogin(false);
  };

  const handleLogin = () => {
    if (email === "" || password === "") {
      alert("Por favor, ingresa tu correo y contraseña");
      return;
    }

    login(email, password);
  };

  return (
    <div className="vizionario-login">
      <div className="vizionario-login-content">
        <h4 className="mb-3">Ingresa los datos de tu cuenta</h4>
        <div className="form-group mb-3">
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-control"
          />
        </div>
        <div className="input-group mb-3">
          <input
            type={passwordType}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
            placeholder="Contraseña"
            aria-label="Contraseña"
            aria-describedby="basic-addon2"
          />
          <button
            onClick={() =>
              setPasswordType(passwordType === "password" ? "text" : "password")
            }
            className="input-group-text"
            id="basic-addon2"
          >
            {passwordType === "password" ? (
              <img alt="open-eye" src={openEye} />
            ) : (
              <img alt="close-eye" src={closeEye} />
            )}
          </button>
        </div>
        <div className="vizionario-menu">
          {!loading ? (
            <>
              <button onClick={handleCancel}>Cancelar</button>
              <button onClick={handleLogin} className="login">
                Iniciar sesión
              </button>
            </>
          ) : (
            <img alt="loading" src={spinner} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
